<template>
  <GBox class="slider-wrapper">
    <GIcon
      name="arrow-left-circle"
      class="icon swiper-prev-btn"
      @click="onPrev"
    />
    <Swiper
      class="swiper"
      :options="swiperOption"
      @transitionStart="onSlideNextTransitionStart"
      ref="swiper"
    >
      <SwiperSlide
        class="each-slide"
        v-for="({image, title, content}, idx) in slides"
        :key="idx"
      >
        <AnnouncementSlide
          :image="image"
          :title="title"
          :content="content"
        />
      </SwiperSlide>
      <div
        class="swiper-pagination"
        slot="pagination"
      />
    </Swiper>
    <GIcon
      name="arrow-right-circle"
      class="icon swiper-next-btn"
      @click="onNext"
    />
  </GBox>
</template>

<script>
import GBox from '@trendyol-js/grace/core/GBox';
import GIcon from '@trendyol-js/grace/core/GIcon';
import AnnouncementSlide from '@/views/LoginNew/AnnouncementSlide';

export default {
  name: 'AnnouncementSlider',

  components: {
    AnnouncementSlide,
    GBox,
    GIcon,
  },

  data () {
    return {
      activeSlideIndex: 0,
      swiperOption: {
        loop: true,
        init: false,
        pagination: {
          el: '.swiper-pagination',
          dynamicBullets: true,
        },
        navigation: {
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
        },
        autoplay: {
          delay: 10000,
          disableOnInteraction: false,
        },
      },
    };
  },

  methods: {
    onNext () {
      this.swiper.slideNext(500);
    },
    onPrev () {
      this.swiper.slidePrev(500);
    },
    onSlideNextTransitionStart () {
      this.activeSlideIndex = this.swiper.realIndex;
    },
  },

  computed: {
    /* istanbul ignore next */
    swiper () {
      return this.$refs.swiper.$swiper;
    },

    slides () {
      return [
        {
          title: 'Trendyol ile İşinizi Büyütün!',
          content: `
            Trendyol ile çalışmaya başladıktan
            sonra:
            Ciromuzu artırdık diyen satıcıların oranı
            <b>%90</b><br>
            İstihdamımızı artırdık diyen satıcıların oranı
            <b>%92</b><br>
          `,
          image: 'slide-1-new.svg',
        },
        {
          title: 'Yerli Üretime Katkı',
          content: `
            Trendyol'daki satıcıların <b>%98'i</b><br>
            yerli şirketlerden oluşuyor.<br><br>
            Trendyol.com'da satılan ürünlerin <br>
            <b>%72</b>'sinin imalatı Türkiye'de yapılıyor.<br><br>
            <b>14 bin</b> Trendyol satıcısı Trendyol'da<br>
            satışa başladıktan sonra Türkiye'de<br>
             üretime başladı.
          `,
          image: 'slide-2.svg',
        },
        {
          title: 'Trendyol Aktif Müşteri Sayıları',
          content: `
            2019 yılında aktif müşteri sayımız:<br>
            <b>9.2 milyon</b> kişi<br><br>
            2020 yılında aktif müşteri sayımız:<br>
            <b>19.3 milyon</b> kişi
          `,
          image: 'slide-3.svg',
        },
        {
          title: 'Fatura Süreçlerinizi Dijitalleştirin!',
          content: `
            Trendyol E-Faturam ile faturalarınızı<br>
            elektronik olarak kesebilirsiniz. Üstelik ilk <br>
            paketinizi aldıktan sonra fatura kesimi ilk<br>
            <b>5 ay ücretsiz ve sınırsız.</b>
          `,
          image: 'slide-4.svg',
        },
        {
          title: 'Tüm İhtiyaçlarınız Çözüm Ortaklarında!',
          content: `
            Ürün fotoğraf çekimi, kutu & ambalaj
            tedariği, akaryakıt indirimi, bankacılık
            hizmetleri, ürün içerik üretimi ve daha
            bir çok ihtiyacınıza özel çözümleri
            <b>Trendyol Çözüm Ortakları</b>'nda bulabilirsiniz.
          `,
          image: 'slide-5.svg',
        },
      ];
    },
  },

  async mounted () {
    this.activeSlideIndex = this.swiper.realIndex;

    setTimeout(() => {
      this.swiper.init();
    }, 700);
  },

  watch: {
    activeSlideIndex (newValue) {
      this.$emit('onActiveSliderIndexChange', newValue);
    },
  },
};
</script>

<style lang="scss" scoped>
.slider-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
  max-width: 100%;

  .swiper {
    width: 100%;

    .swiper-slide {
      display: flex;
      justify-content: center;
    }
  }

  ::v-deep .swiper-pagination-bullet-active {
    background-color: var(--orange-500);
  }

  .icon {
    cursor: pointer;
    color: var(--orange-500);

    &:hover {
      filter: invert(50%);
    }
  }

  @media only screen and (max-width:425px) {
    display: flex;
    align-items: center;
    justify-content: center;
  }
}
</style>
